module.exports = __webpack_public_path__ + "static/media/algolia-logo-white.a44a3efb.svg";